import React, { useEffect, useContext } from 'react'
import './AddCertificate.css'
import Modal from '../../../../components/modal/Modal'
import { ModalBody, ModalFooter } from '../../../../components/modal'
import * as actions from '../store/actions'
import { AppContext } from '../../../../global'
import { useTranslation } from 'react-i18next'
import { RequestState } from '../../../types'
import { Certificate } from '../store/store'
import FormFieldSelect from '../../../../components/forms/FormFieldSelect'
import FormFieldText from '../../../../components/forms/FormFieldText'

type Props = {
  accountId: string
  onCancel: () => void
  onAddCertificate: (certificate: Certificate, label: string) => void
}

export default function AddCertificate(props: Props) {
  const { onCancel, onAddCertificate } = props
  const { accountId } = props
  const { state, execute } = useContext(AppContext)
  const certificateState = state.settings.certificates
  const { t } = useTranslation(['global', 'settings_certificates'])

  const selectEnabled =
    certificateState.add.requestState === RequestState.Loaded &&
    certificateState.add.certificate !== ''

  useEffect(() => {
    execute(actions.loadAvailableCertificates(accountId))
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accountId])

  useEffect(() => {
    execute(actions.updateCertFormField('name', ''))
    execute(actions.updateCertFormField('certificate', ''))
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  function addCertificate() {
    const selectedCert = certificateState.add.certificate
    const certificateCatalogue = certificateState.add.catalogue
    const certificate = certificateCatalogue.find(cert => cert.key === selectedCert)

    if (certificate) {
      onAddCertificate(certificate, certificate?.label)
    }
  }

  function onSelectCert(key: string) {
    const certificateCatalogue = certificateState.add.catalogue
    const certificate = certificateCatalogue.find(cert => cert.key === key)

    execute(actions.updateCertFormField('certificate', key))
    const certificateText = certificate ? certificate.label : ''
    execute(actions.updateCertFormField('name', certificateText))
  }

  function onFieldChange(key: string, value: string) {
    execute(actions.updateCertFormField(key, value))
  }

  return (
    <Modal title={t('settings_certificates:add_certificate')} >
      <ModalBody>
        <div id="cert-container">
          {certificateState.add.requestState === RequestState.Loaded && (
            <>
              <FormFieldSelect
                data-cy="cert-field-select"
                title={t('settings_certificates:certificate')}
                placeholder={t('global:please_select')}
                value={certificateState.add.certificate}
                onChange={(value: string) => onSelectCert(value)}
                options={
                  certificateState.add.catalogue.map(c => (
                    {
                      key: c.key,
                      text: c.label
                    }
                  ))
                } />

              <div className="spacer">
                <FormFieldText
                  title={t('settings_certificates:name')}
                  value={certificateState.add.name}
                  placeholder={t('settings_certificates:enter_name')} 
                  onChange={(value: string) => onFieldChange('name', value)} />
              </div>
            </>
          )}

          {certificateState.add.requestState === RequestState.Loading && (
            <div id="loading-container">
              <i className="fas fa-spinner fa-spin font-size-xl"></i>
              <span>{t('loading')}</span>
            </div>
          )}

          {certificateState.add.requestState === RequestState.Error && (
            <span>
              {t('settings_certificates:cannot_load')}
            </span>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <button onClick={onCancel}>{t('global:cancel')}</button>
        <button data-cy="select" onClick={addCertificate} disabled={!selectEnabled}>{t('global:select')}</button>
      </ModalFooter>
    </Modal >
  )
}
